import React from 'react';
import AprCalc from '.././components/AprCalc.js';

export default function Apr() {
  return (

  <>
  <div className="flex content-center items-center text-xl text-stone-300">
    <AprCalc/>
  </div>
  </>

)
}
